export class ProyectoAccesoCategoria {
  idProyectoAcceso: number;
  idProyecto: number;
  tipoAceso?: number;
  idEstatus: number;
  fechaHoraUM: string;
  idUsuarioUM: number;
}
